//@flow
import styled from "styled-components"

const ImagePreview = styled.img`
  max-width: 100%;
  max-height: 100%;
`

export default ImagePreview



// WEBPACK FOOTER //
// ./src/UI/FileUploader/ImagePreview.js